/**
 * @desc: - 投注选号 - 对决（一共10组对决）
 * @param  {[STRING]} className：   [顶层 class]
 * @param  {[STRING]} values        [当前选中值]
 * @param  {[FUNCTION]} onChange:   [变更时候的方法]
 * @author: ammo
 */
export default class BetPK extends React.Component {

	constructor(props) {
		super(props);
    this.codeList = ['01','02','03','04','05','06','07','08','09','10'];
    this.handleSelectCode = this.handleSelectCode.bind(this);
    this.state = {
      disabledCode: null
    }
	}

	// 选择球球
  handleSelectCode(code){
    // 禁用当前号返回
    if (code == this.state.disabledCode) {return}
    const { values, onChange } = this.props;
    let mergeCode = [], result = _.cloneDeep(values);
    // 确定当前位置
    _.forEach(values, function(item, index){
      mergeCode = _.concat(mergeCode, item)
    })
    const position = mergeCode.length;
    const index = Math.ceil(position / 2);
    const isOdd = position % 2 == 1 ? true : false;
    // 已经满了
    if (position == 20) {return}
    // 当前单数位置
    if (isOdd) {
      result[index - 1][1] = code;
    }
    // 当前偶数位置
    if (!isOdd && position != 0) {
      result[index][0] = code;
    }
    // 第一个位置
    if (position == 0) {
      result[0][0] = code;
    }
    // 禁用当前号
    if (isOdd) {
      this.setState({
        disabledCode: null
      })
    }else{
      this.setState({
        disabledCode: code
      })
    }
    onChange(result);
  }

  // 清空
  handleClear(index){
    const { values, onChange } = this.props;
    let mergeCode = [], result = _.cloneDeep(values);
    if (index != null) {
      result = _.remove(result, function(item, idx){
        return index != idx
      })
      result[9] = [];
    }else{
      result = [[],[],[],[],[],[],[],[],[],[]];
    }
    // 确定当前位置
    _.forEach(result, function(item, index){
      mergeCode = _.concat(mergeCode, item)
    })
    const position = mergeCode.length;
    const isOdd = position % 2 == 1 ? true : false;
    if (!isOdd) {
      this.setState({
        disabledCode: null
      })
    }
    onChange(result);
  }

	render() {
		const {className, values} = this.props;
		return (
      <div className={'bet-pk ' + className}>
  			<div className="left">
          <div className="each ele-item">
            <h4 className="noname"></h4>
            <ul className="nList">
              {
                this.codeList.map((elem, index) => 
                  <li 
                    onClick={this.handleSelectCode.bind(this,elem)} 
                    key={index} 
                    className={this.state.disabledCode == elem ? 'disable item_'+elem : 'item_' + elem}> 
                    {elem}
                  </li>
                )
              }
            </ul>
          </div>
          <div className="each select-code fast_code">
            <h4 className="noname"></h4>
            <ul className="nList">
              {
                values.map((code, index) => 
                  code[0] ? <li key={index} className={'num_' + code[0]} ></li> : null
                )
              }
            </ul>
          </div>
          <div className="each select-code slow_code">
            <h4 className="noname"></h4>
            <ul className="nList">
              {
                values.map((code, index) => 
                  code[1] ? <li key={index} className={'num_' + code[1]} ></li> : null
                )
              }
            </ul>
          </div>
          <div className="each clean">
            <h4 className="noname"></h4>
            <ul className="nList">
              {
                this.codeList.map((elem, index) => 
                  <li onClick={this.handleClear.bind(this,index)} key={index} >清</li>
                )
              }
            </ul>
          </div>
  			</div>
        
        <br className="clearfix" />
      </div>
		);
	}
}
